function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  border-bottom: 1px solid #e5e7eb;\n  position: relative;\n  z-index: 10;\n  background-color: var(--theme-background, #ffffff);\n  \n  html.dark &, body.dark &, body.vscode-dark & {\n    border-bottom: 1px solid #374151;\n    background-color: var(--theme-background-dark, #111827);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  width: 100%;\n  justify-content: flex-start; /* 탭을 왼쪽 정렬 */\n  gap: 0; /* 탭 간 간격 없음 */\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background-color: #3b82f6;\n  border-radius: 9999px;\n  z-index: 1;\n  \n  html.dark &, body.dark &, body.vscode-dark & {\n    background-color: #60a5fa;\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #3b82f6;\n  border-bottom: 2px solid #3b82f6;\n  z-index: 1;\n  \n  html.dark &, body.dark &, body.vscode-dark & {\n    background-color: #60a5fa;\n    border-bottom: 2px solid #60a5fa;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  flex: 0 0 auto; /* flex: 1 제거, 콘텐츠 크기에 맞춤 */\n  min-width: 100px; /* 최소 너비 설정 */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  transition: all 0.2s ease-in-out;\n  background: transparent;\n  \n  font-weight: ",
        " !important;\n  color: ",
        " !important;\n  border-radius: 0 !important;\n  padding: 0.75rem 1.5rem !important; /* 좌우 패딩 추가 */\n  \n  html.dark &, body.dark &, body.vscode-dark & {\n    color: ",
        " !important;\n  }\n  \n  &:hover {\n    background-color: ",
        " !important;\n    color: ",
        " !important;\n    \n    html.dark &, body.dark &, body.vscode-dark & {\n      background-color: ",
        " !important;\n      color: ",
        " !important;\n    }\n  }\n  \n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n    &:hover {\n      background-color: #f3f4f6;\n      \n      html.dark &, body.dark &, body.vscode-dark & {\n        background-color: #1f2937;\n      }\n    }\n  "
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n    &:hover {\n      color: #1f2937;\n      \n      html.dark &, body.dark &, body.vscode-dark & {\n        color: #e5e7eb;\n      }\n    }\n  "
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  flex: 1;\n  padding: 0.75rem 0;\n  font-weight: ",
        ";\n  text-align: center;\n  position: relative;\n  color: ",
        ";\n  \n  html.dark &, body.dark &, body.vscode-dark & {\n    color: ",
        ";\n  }\n  \n  ",
        "\n  \n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
import { css } from '@emotion/react';
// 탭 컨테이너 스타일
export var TabContainer = styled.div(_templateObject());
// 탭 버튼 레이아웃 컨테이너
export var TabButtonsContainer = styled.div(_templateObject1());
// 하단 인디케이터 - indicator 변형
export var TabIndicator = styled.div(_templateObject2());
// 하단 인디케이터 - border 변형
export var TabBorder = styled.div(_templateObject3());
// Button 컴포넌트를 확장한 StyledTabButton
export var StyledTabButton = styled.button(_templateObject4(), function(props) {
    return props.$isActive && props.$tabVariant === 'border' ? 700 : 500;
}, function(props) {
    return props.$isActive ? '#000000' : '#6b7280';
}, function(props) {
    return props.$isActive ? '#ffffff' : '#9ca3af';
}, function(props) {
    return !props.$isActive && props.$tabVariant === 'border' ? '#f3f4f6' : 'transparent';
}, function(props) {
    return !props.$isActive && props.$tabVariant === 'indicator' ? '#1f2937' : '';
}, function(props) {
    return !props.$isActive && props.$tabVariant === 'border' ? '#1f2937' : 'transparent';
}, function(props) {
    return !props.$isActive && props.$tabVariant === 'indicator' ? '#e5e7eb' : '';
});
// 기존 TabButton - 호환성을 위해 유지
export var TabButton = styled.button(_templateObject7(), function(props) {
    return props.isActive && props.variant === 'border' ? '700' : '500';
}, function(props) {
    return props.isActive ? '#000000' : '#6b7280';
}, function(props) {
    return props.isActive ? '#ffffff' : '#9ca3af';
}, function(props) {
    return !props.isActive && props.variant === 'border' && css(_templateObject5());
}, function(props) {
    return !props.isActive && props.variant === 'indicator' && css(_templateObject6());
});
